/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/spinner/custom-elements';

import { defineCustomElement as defineOsdsSpinner } from '@ovhcloud/ods-stencil/components/spinner/custom-elements/osds-spinner.js';


export const OsdsSpinner = /*@__PURE__*/ defineContainer<JSX.OsdsSpinner>('osds-spinner', defineOsdsSpinner, [
  'contrasted',
  'flex',
  'mode',
  'size'
]);

